/*
@ngdoc directive
@name listingResults
@restrict 'EA'
@scope true
@description
It just calculates and displays Results for listing pagination (calculations within the template).
*/

(function() {
  'use strict'

  const listingResults = ($timeout, $templateCache) => {
    return {
      scope: true,
      bindToController: { listingModel: '&listingResults' },
      controllerAs: 'ctrl',
      controller: () => {},
      restrict: 'EA',
      replace: true,
      template: $templateCache.get('components/listing/listingResults.html'),
    }
  }

  listingResults.$inject = ['$timeout', '$templateCache']
  angular.module('app').directive('listingResults', listingResults)
// eslint-disable-next-line semi
}());
